/**
 * WP11c / #46647 — client read of the HG9 rollback stamp.
 *
 * The host stamps `data-verification-rollback="engaged"` on `<html>` when the
 * named trigger fires (`excellent/server/verification-rollback.ts`). `/` reads
 * this synchronously so the first paint is the restored old shell, not a flash
 * of the verification IA. `/classic` stays the archive path either way.
 */

export const ROLLBACK_ATTR = "data-verification-rollback";
export const ROLLBACK_ENGAGED_VALUE = "engaged";

export function isVerificationRollbackEngaged(): boolean {
  if (typeof document === "undefined") return false;
  return document.documentElement.getAttribute(ROLLBACK_ATTR) === ROLLBACK_ENGAGED_VALUE;
}
